import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Page from 'src/components/Page';

const Bg = () => (
  <svg width="1280" height="800" viewBox="0 0 1280 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <rect y="-20" width="1280" height="1280" rx="20" fill="#29307E" />
    </g>
    <mask id="mask0" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="-20" width="1280" height="1280">
      <rect y="-20" width="1280" height="1280" rx="20" fill="white" />
    </mask>
    <g mask="url(#mask0)">
      <g opacity="0.4">
        <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M-132 -337.075L682.178 -807L1690 938.075L875.822 1408L-132 -337.075Z" fill="url(#paint0_linear)" />
        <path opacity="0.313519" fillRule="evenodd" clipRule="evenodd" d="M734.242 -1003L1399 -338.242L-26.2418 1087L-691 422.242L734.242 -1003Z" fill="#A75EEA" />
        <path opacity="0.313519" fillRule="evenodd" clipRule="evenodd" d="M865.242 -473L1530 191.758L104.758 1617L-560 952.242L865.242 -473Z" fill="#A840F4" />
        <path opacity="0.620301" fillRule="evenodd" clipRule="evenodd" d="M512 -145.075L1326.18 -615L2334 1130.07L1519.82 1600L512 -145.075Z" fill="url(#paint1_linear)" />
        <path opacity="0.620301" fillRule="evenodd" clipRule="evenodd" d="M696 -598.075L1510.18 -1068L2518 677.075L1703.82 1147L696 -598.075Z" fill="url(#paint2_linear)" />
      </g>
    </g>
    <defs>
      <filter id="filter0_d" x="-50" y="-50" width="1380" height="1380" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="25" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.796078 0 0 0 0 0.411765 0 0 0 0 0.956863 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <linearGradient id="paint0_linear" x1="158.982" y1="244.792" x2="406.853" y2="1068.39" gradientUnits="userSpaceOnUse">
        <stop stopColor="#5376F1" />
        <stop offset="1" stopColor="#B50FAE" />
      </linearGradient>
      <linearGradient id="paint1_linear" x1="373.028" y1="615.556" x2="1036.25" y2="2435.56" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E487FF" />
        <stop offset="1" stopColor="#FF51F8" />
      </linearGradient>
      <linearGradient id="paint2_linear" x1="557.028" y1="162.556" x2="1220.25" y2="1982.56" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF87BF" />
        <stop offset="1" stopColor="#FF51F8" />
      </linearGradient>
    </defs>
  </svg>
);

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: 'center',
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    paddingBottom: 80,
    paddingTop: 80
  },
}));

function AuthLayout({ children }) {
  const classes = useStyles();

  const svgString = encodeURIComponent(renderToStaticMarkup(<Bg />));
  const dataUri = `url("data:image/svg+xml,${svgString}")`;

  return (
    <Page
      className={classes.root}
      title="Mercury"
      style={{
        background: dataUri,
        backgroundSize: 'cover'
      }}
    >
      {children}
    </Page>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AuthLayout;
